import { render, staticRenderFns } from "./VerifyCodeModal.vue?vue&type=template&id=b125fcd8"
import script from "./VerifyCodeModal.vue?vue&type=script&lang=js"
export * from "./VerifyCodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports